import { useQuery } from 'react-query'
import request from '../../request'
import { QUERY_CURRENT_USER } from '../../queryKeys/currentUser'

const useCurrentUser = () => useQuery(QUERY_CURRENT_USER, () => request({ endpoint: '/users/me' }))

export default useCurrentUser
